<mat-select
    [(value)]="appLanguage"
    (selectionChange)="changeLanguage.emit($event)"
>
    <ng-container *ngFor="let lang of languages">
        <mat-option [value]="lang?.alpha2Code">{{lang?.alpha2Code | uppercase}}</mat-option>
    </ng-container>

</mat-select>